export default "__VITE_ASSET__DK2mR45m__"